import { render, staticRenderFns } from "./CosmoTourPreview.vue?vue&type=template&id=011c6ce5&lang=pug&"
import script from "./CosmoTourPreview.vue?vue&type=script&lang=js&"
export * from "./CosmoTourPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports